var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisclosureUp16Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96967 10.7809C3.26256 11.0738 3.73744 11.0738 4.03033 10.7809L8 6.81126L11.9697 10.7809C12.2626 11.0738 12.7374 11.0738 13.0303 10.7809C13.3232 10.488 13.3232 10.0132 13.0303 9.72027L8 4.68994L2.96967 9.72027C2.67678 10.0132 2.67678 10.488 2.96967 10.7809Z",
    fill: "white",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclosureUp16Line);
export default __webpack_public_path__ + "static/media/Disclosure-Up-16-line.7b07b3dca362c55abf98c1d7acf422f6.svg";
export { ForwardRef as ReactComponent };